var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{attrs:{"to":_vm.targetRoute}},[_c('pwr-menu-btn',{attrs:{"route-name-reference":_vm.routeData.name},on:{"click":_vm.onClick}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }